"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var MuiTooltip = {
  arrow: true,
  placement: 'top-end',
  title: null,
  children: null
};
var _default = MuiTooltip;
exports["default"] = _default;